export enum PaidState {
  PAID = "paid",
  PENDING = "pending",
  UNPAID = "unpaid",
}
